<template>
  <div class="wrapper">
    <div class="wrapper-tags-pagination">
      <div class="pagination-block">
        <Pagination :pages="pagination"/>
      </div>
      <div>
        <button class="btn btn-success"
                data-target="#newOrder"
                data-toggle="modal"
                style="border-radius: 50%;"
                @click="addNewOrder = true">+</button>

        <i
            v-show="Object.keys(queryObject).length > 1"
            class="fas fa-sync"
            style="cursor: pointer; margin-left: 8px"
            title="Reset"
            @click="resetTable"
        ></i>
      </div>
    </div>
    <div class="Rtable Rtable--5cols Rtable--collapse">
      <div class="Rtable-row Rtable-row--head">
        <div class="Rtable-cell cb-cell column-heading"><input type="checkbox" /></div>
        <div class="Rtable-cell id-cell column-heading">ID</div>
        <div class="Rtable-cell contact-cell column-heading">Contact</div>
        <div class="Rtable-cell status-cell column-heading">Status</div>
        <div class="Rtable-cell types-cell column-heading">Types</div>
<!--        <div class="Rtable-cell photos-cell column-heading">Photos</div>-->
        <div class="Rtable-cell kind-cell column-heading">Kind</div>
        <div class="Rtable-cell language-cell column-heading">Language</div>
        <div class="Rtable-cell country-cell column-heading">Country</div>
        <div class="Rtable-cell overall-cell column-heading">Overall Price</div>
        <div class="Rtable-cell price_plus_vat-cell column-heading">Price + VAT</div>
        <div class="Rtable-cell discount-cell column-heading">Discount</div>
        <div class="Rtable-cell price_after_discount-cell column-heading">P.after discount</div>
        <div class="Rtable-cell projected_job_span-cell column-heading">P. job time</div>
        <div class="Rtable-cell order_date-cell column-heading">Order Date</div>
        <div class="Rtable-cell projected_finish_date-cell column-heading">P. finish time</div>
        <div class="Rtable-cell created_at-cell column-heading">Created At</div>
        <div class="Rtable-cell tags-cell column-heading">tags</div>
      </div>
      <Order
          v-for="(order, index) in orders"
          :key="index"
          :order="order"
          :columnSize="columnSize"
      />
    </div>
    <add-new-order :new-order="addNewOrder" @cancelAddNewOrder="addNewOrder = false" @fetchNewOrdersList="fetchOrders()"></add-new-order>
  </div>
</template>

<script>
import moment from "moment";
import Order from "../components/Order.component";
import AddNewOrder from "../components/addOrder/AddNewOrder.component"
import Pagination from "../../contacts/components/Pagination.component";
// import OrderModel from "../components/OrderModel";
// import MultiSelect from "../../../company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/MultiSelect.container";
import apiClientCreator from "@/helpers/api/request";

export default {
  name: "OrdersTable",
  props:{
    orderDates:{
      type: Object,
      default: null
    }
  },
  components: {
    Pagination,
    Order,
    AddNewOrder,
    // MultiSelect
  },
  data() {
    return {
      queryObject: {page: 1},
      orders: [],
      columnSize: {},
      addNewOrder: false,
      pagination: {
        currentPage: 1,
        perPage: 7,
        from: 1,
        to: 1,
        lastPage: 1,
        total: 0
      },
    };
  },
  mounted() {
    this.fetchOrders()
  },
  methods:{
    async fetchOrders() {
      this.addNewOrder = false
      let getOrdersList = apiClientCreator("projects/orders/list");
      let result = await getOrdersList.get("", { params: this.queryObject });
      this.orders = result.data.data;
      this.pagination.currentPage = result.data.current_page;
      this.pagination.perPage = result.data.per_page;
      this.pagination.total = result.data.total;
      this.pagination.lastPage = result.data.last_page;
      this.pagination.to = result.data.to;
      this.pagination.from = result.data.from;
    },
    resetTable() {
      this.queryObject = { page: 1 };
      this.pagination =  {
        currentPage: 1,
            perPage: 7,
            from: 1,
            to: 1,
            lastPage: 1,
            total: 0
      };
      this.fetchOrders();
    },
  },
  watch: {
    orderDates: function(){
      // console.log(this.orderDates)
      if(this.orderDates !== null){
        this.queryObject = Object.assign({}, this.queryObject, {
          order_date_from: moment(this.orderDates.date.start).format("YYYY-MM-DD"),
          order_date_to: moment(this.orderDates.date.end).format("YYYY-MM-DD")
        });
        this.fetchOrders()
      }
    }
  }
};
</script>

<style scoped lang="scss">
$breakpoint: 750px;
$heading-color: white;

* {
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
}

.is-striped {
  background-color: rgba(233, 200, 147, 0.2);
}

/* Table column sizing
================================== */
.cb-cell {
  width: 2%;
}
.id-cell {
  width: 2%;
}
.contact-cell {
  width: 3.4%;
}

.status-cell {
  width: 3.4%;
}
.types-cell {
  width: 3.4%;
}

/*.photos-cell {
  width: 6.4%;
}*/
.kind-cell {
  width: 3.4%;
}
.language-cell {
  width: 3.4%;
}

.country-cell {
  width: 3.4%;
}
.order_date-cell {
  width: 3.4%;
}
.created_at-cell {
  width: 3.4%;
}


.overall-cell {
  width: 3.4%;
}
.price_plus_vat-cell {
  width: 3.4%;
}

.discount-cell {
  width: 3.4%;
}
.price_after_discount-cell {
  width: 3.4%;
}
.projected_job_span-cell {
  width: 3.4%;
}
.projected_finish_date-cell {
  width: 3.4%;
}
.tags-cell {
  width: 50%;
}



/* Apply styles
================================== */
.Rtable {
  display: flex;
  flex-wrap: wrap;
  //margin: 0 0 3em 0;
  padding: 0;
  //box-shadow: 0 0 40px rgba(0,0,0,0.2);

  .Rtable-row {
    width: 100%;
    display: flex;

    .Rtable-cell {
      box-sizing: border-box;
      flex-grow: 1;
      //padding: 0.8em 1.2em;
      padding: 1% 1%;
      overflow: hidden; // Or flex might break
      list-style: none;

      &.column-heading {
        background-color: $heading-color;
        padding: 0.5em;
        border-bottom: 2px solid #d7d7d7;
        border-top: 2px solid #d7d7d7;
        font-weight: 600;
        font-size: 13px;
        text-align: center;
      }

      .Rtable-cell--heading {
        display: none;
      }

      .Rtable-cell--content {
        a {
          font-size: 2em;
          color: #333;
        }

        .webinar-date {
          font-weight: 700;
        }
      }
    }
  }
}

/* Responsive
==================================== */
//@media wrapper-tags-pagination and (max-height: 50px) {
//  .wrapper-tags-pagination{
//    flex-direction: column;
//    height: fit-content;
//  }
//}
@media all and (max-width: $breakpoint) {
  .is-striped {
    background-color: white;
  }

  .Rtable--collapse {
    display: block;
    width: 100%;
    padding: 1em;
    box-shadow: none;

    .Rtable-row {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2em;
      box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);

      .Rtable-cell {
        width: 100% !important;
        display: flex;
        align-items: center;

        .Rtable-cell--heading {
          display: inline-block;
          flex: 1;
          max-width: 120px;
          min-width: 120px;
          color: $heading-color;
          font-weight: 700;
          border-right: 1px solid #ccc;
          margin-right: 1em;
        }

        .Rtable-cell--content {
          flex: 2;
          padding-left: 1em;
        }
      }
    }

    .topic-cell {
      background-color: $heading-color;
      color: white;
      font-weight: 700;
      order: -1;

      .Rtable-cell--content {
        padding-left: 0 !important;
      }
    }

    .Rtable-row--head {
      display: none;
    }
  }

  .wrapper-tags-pagination {
    flex-direction: column;
    height: fit-content !important;
  }
}

// Non-Flex modernizer fallback
.no-flexbox .Rtable {
  display: block;

  &.Rtable-cell {
    width: 100%;
  }
}
.wrapper-tags-pagination {
  display: flex;
  height: 50px;
  margin-right: 125px;
  margin-left: 10px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  justify-content: space-between;
  flex-direction: row-reverse;
}

.menu-block {
  flex: 2;
}
.tabs-block {
  flex: 17;
}
.pagination-block {
  width: 100px;
  padding-bottom: 10px;
}
.input-main-multi-select {
  position: relative;
  display: inline-block;
  border: 1px solid #d7d7d7;
  height: 30px;
  width: 100%;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  text-transform: capitalize;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 5px;
  min-width: 100%;
}
</style>
